export default __webpack_public_path__ + "static/media/potion_03.d8ba660b.png";